<template>
  <div class="editor-content">
    <div
      class="editor-box"
      :placeholder="placeholder"
      :class="{'show-placeholder':showPlaceholder,'realHeight':needSignatureFlag}"
    >
      <div
        class="edit-panel"
        contenteditable="true"
        @input="handleInput"
        @click="getCursorRect($event)"
        @paste="onPaste"
        @keydown="handleDOMRemoved"
        ref="editor"
      ></div>
      <div class="publish-tools">
        <filebox :deletebnt="true" :swiper="true" :fileInfo="replyResult.fileInfo"></filebox>
        <div class="tools">
          <div @click="clickAt">
            <img src="@/assets/icon/icon-at.png" />
          </div>
          <div>
            <Upload
              :show-upload-list="false"
              :action="serviceUrl+'/api/FileManagement/uploadImage'"
              multiple
              accept="image/*"
              :on-success="clickImg"
              :format="['jpg','jpeg','png']"
              :before-upload="handleBeforeUpload"
            >
              <img src="@/assets/icon/icon-tupian.png" />
            </Upload>
          </div>
          <div>
            <Upload
              :show-upload-list="false"
              :action="serviceUrl+'/api/FileManagement/uploadImage'"
              multiple
              :on-success="clickImg"
              :before-upload="handleBeforeUpload"
            >
              <img src="@/assets/icon/icon-fujian.png" />
            </Upload>
          </div>
        </div>
      </div>
    </div>
    <div v-if="needSignatureFlag" class="needSignatureFlag">
      <Form>
        <FormItem label="是否需要签名标记">
          <RadioGroup v-model="replyResult.needSignatureFlag">
            <Radio label="YES">需要</Radio>
            <Radio label="NO">不需要</Radio>
          </RadioGroup>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import * as dd from "dingtalk-jsapi";

import {
  insertHtmlAtCaret,
  getCursortPosition,
  setCursorPosition
} from "@/utils/editor/editorUtils";
import { mapState } from "vuex";
import http from "@/utils/http";
import filebox from "./Preview/fileBox";
const { Service_API_URL } = require(`@/config/develop.json`);
export default {
  props: {
    placeholder: {
      default: "请输入你的意见"
    },
    //编辑完返回的实体
    replyResult: {},
    needSignatureFlag: {
      default: false
    }
  },
  data() {
    return {
      contentValue: "",
      serviceUrl: "",
      currentlength: 0, //光标之前长度
      afterlength: 0, //光标之后长度
      editor: {},
      num: 0
    };
  },
  computed: {
    ...mapState({
      dingdingconfig: state => state.dingdingconfig,
      browser: state => state.browser
    }),
    showPlaceholder() {
      // 判断是否有内容显示 placeholder
      return this.contentValue.length === 0;
    }
  },
  mounted() {
    // 初始化的时候让输入框自动聚焦
    this.$nextTick(() => {
      this.editor = this.$refs.editor;
      //this.$refs.editor.focus();
    });
    this.serviceUrl = Service_API_URL;
  },
  watch: {
    contentValue(val) {
      //   this.$refs.editor.value = val;
      this.replyResult.replyText = this.$refs.editor.innerHTML;
    }
  },
  methods: {
    handleBeforeUpload() {
      if (this.replyResult.fileInfo.filesrcs.split("|").length > 9) {
        return false;
      }
      return true;
    },
    clickImg(response, file, fileList) {
      this.replyResult.fileInfo.filesrcs += response.data + "|";
      this.replyResult.fileInfo.filenames += file.name + "|";
    },
    clickAt() {
      let _this = this;
      // let approverList = [
      //   {
      //     userId: "060040153535982206",
      //     name: "赵金建"
      //   },
      //   {
      //     userId: "060040153535982207",
      //     name: "韦丰"
      //   }
      // ];
      this.complexChoose().then(approverList => {
        if (approverList && approverList.length > 0) {
      _this.replyResult.atPeople.push(...approverList);
      _this.addTopic(approverList);
        }
      });
    },
    //弹出通讯录
    complexChoose() {
      let _this = this;
      return new Promise(function(resolve, reject) {
        dd.biz.contact.complexPicker({
          title: "选择员工", //标题
          corpId: _this.dingdingconfig.corpId, //企业的corpId
          multiple: true, //是否多选
          limitTips: "超出了", //超过限定人数返回提示
          maxUsers: 50, //最大可选人数
          pickedUsers: [], //已选用户
          pickedDepartments: [], //已选部门
          disabledUsers: [], //不可选用户
          disabledDepartments: [], //不可选部门
          requiredUsers: [], //必选用户（不可取消选中状态）
          requiredDepartments: [], //必选部门（不可取消选中状态）
          appId: _this.dingdingconfig.agentId, //微应用的Id
          permissionType: "GLOBAL", //可添加权限校验，选人权限，目前只有GLOBAL这个参数
          responseUserOnly: true, //返回人，或者返回人和部门
          startWithDepartmentId: -1, //仅支持0和-1
          onSuccess: function(result) {
            result.users.forEach(item => {
              item.userId = item.emplId;
              item.cid = "";
            });
            resolve(result.users);
          },
          onFail: function(err) {
            resolve({});
          }
        });
      });
    },
    async addTopic(list) {
      // textareaStr.replace(/\>@(.+?)\</g, "");
      var _this = this;
      var textareaStr = this.editor.innerHTML;
      let cursor_before_str = await this.getCursorText(this.editor);
      var reg = /<button contenteditable="false" class="user-btn" userid="(.*?)">(.*?)<\/button>/g;
      this.num = 0;
      var a = cursor_before_str.match(reg);
      if (a) {
        a.forEach(item => {
          _this.num += item.replace(/\>@(.+?)\</g, "").length + 2;
        });
      }
      //num = num * 71;
      var currentStr = textareaStr.substring(0, this.currentlength + _this.num);
      var afterStr = textareaStr.substring(this.currentlength + _this.num);
      var input = "";
      var lng = 0;
      list.forEach(element => {
        //input += `<button class="user-btn">@${element.name}</button>&#8203;`;
        lng += element.name.length + 2;
        input += `<button contenteditable="false" class="user-btn" userid="${element.userId}">@${element.name}</button>&#8203;`;
      });
      this.replyResult.replyText = currentStr + input + afterStr;
      this.editor.innerHTML = currentStr + input + afterStr;
      this.currentlength += lng;
      this.contentValue = "1";
    },
    async getCursorText(editobj) {
      let _this = this;
      let textstr = editobj.innerText.substring(0, this.currentlength);
      let reg = RegExp(/@/g);
      let label_nums = textstr.match(reg) || [];
      if (label_nums.length > 0) {
        let nums = 68 * label_nums.length;
        await label_nums.forEach((item, index) => {
          nums += _this.replyResult.atPeople[index].userId.length;
        });
        return editobj.innerHTML.substring(0, this.currentlength + nums);
      } else {
        return editobj.innerText;
      }
    },
    onPaste(e) {
      e.preventDefault();
      let text = "";
      if (window.clipboardData && window.clipboardData.setData) {
        text = window.clipboardData.getData("text");
      } else {
        text = (e.originalEvent || e).clipboardData.getData("text/plain") || "";
      }
      // 过滤转义html标签
      text = text.replace(/</g, "&lt").replace(/>/g, "&gt");
      text = text.replace(/\r\n/g, "<br>");
      document.execCommand("insertHTML", false, text);
    },
    handleInput() {
      this.contentValue = this.editor.innerText;
      this.replyResult.replyText = this.editor.innerText;
      this.currentlength = this.replyResult.replyText.length - this.afterlength;
    },
    getCursorRect(e) {
      this.types = e.type;
      if (e.type == "blur") {
        // this.lng  = this.getCursorPosition(this.$el.querySelector("#textarea"));
      }
      if (e.type == "click") {
        this.currentlength = getCursortPosition(this.editor);
        console.log(this.currentlength);
        this.afterlength = this.editor.innerText.length - this.currentlength;
      }
    },
    async handleDOMRemoved(e) {
      let _this = this;
      if (e.keyCode === 8) {
        let str = await this.getCursorText(this.editor);
        let obj = str.split("</button>");
        if (obj[obj.length - 1] == "") {
          let a = obj[obj.length - 2];
          if (a) {
            _this.replyResult.atPeople.splice(obj.length - 2, 1);
            console.log(_this.replyResult.atPeople);
          } else {
            console.log("没进来");
          }
        }
        // str.split("</button>").forEach((item, index) => {
        //   console.log("第" + index +'个'+ item);
        // });
      }
    }
  },
  components: {
    filebox
  }
};
</script>
<style lang="less" scoped="scoped">
.editor-content {
  height: 100%;
  .editor-box {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0.053333rem 0;
    font-size: 0.426667rem;
    line-height: 0.533333rem;
    display: flex;
    flex-direction: column;
    .edit-panel {
      width: 100%;
      flex: 1;
      /* 去掉外发光 */
      outline: none;
      overflow: auto;
    }
    .publish-tools {
      min-height: 1.386667rem;
      width: 100%;
      .file {
        width: calc(100% + 0.253333rem);
        display: flex;
        flex-wrap: wrap;
        .file-item {
          position: relative;
          width: 2.533333rem;
          height: 2.533333rem;
          margin-right: 0.253333rem;
          margin-bottom: 0.4rem;
          .img-box {
            width: 2.133333rem;
            height: 2.133333rem;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .close-bnt {
            margin-left: 2.133333rem;
            width: 0.4rem;
            height: 0.4rem;
            background: url("../../assets/icon/icon-delete.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
      .tools {
        height: 1.386667rem;
        display: flex;
        align-items: center;
        div {
          width: 0.56rem;
          height: 0.56rem;
          margin-right: 0.426667rem;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .realHeight {
    height: 93% !important;
  }
  .needSignatureFlag {
    width: 100%;
    height: 7%;
  }
}
.show-placeholder::before {
  content: attr(placeholder);
  color: #555;
  pointer-events: none;
  position: absolute;
}
</style>
<style>
.user-btn {
  background: transparent;
  margin: 0;
  padding: 0;
  border-style: none;
  color: #38b7e9;
}
</style>



// WEBPACK FOOTER //
// src/components/Share/index.vue